<mat-card class="mat-elevation-z8 container-card">
    <!-- Search bar: filtro su "Suggestion" -->
    <app-search-bar [filterFields]="['suggestion']" [filterMap]="{ suggestion: ['suggestion'] }" [filterLabels]="{ suggestion: ['Termine'] }" (filtersChanged)="onFilterChanged($event)">
    </app-search-bar>

    <!-- Tabella condivisa -->
    <app-shared-table [dataSource]="suggestionsDataSource" [displayedColumns]="displayedColumns" [columnLabels]="columnLabels" [nameTable]="'suggestions'" (sortChanged)="onSortChanged($event)" (openModal)="openDialog($event)" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex" (pageChanged)="onPageChanged($event)" [isLoading]="isLoading" [hasError]="hasError">
    </app-shared-table>

    <app-loading [showLoading]="isLoadingFullScreen"></app-loading>
</mat-card>